import { takeLatest, call, put } from 'redux-saga/effects';
import { delay } from 'redux-saga';

import { t } from 'services/translation';
import Api from '../api';
import {
  FETCH_RESOURCE_REQUEST,
  FETCH_RESOURCE_SUCCESS,
  FETCH_RESOURCE_ERROR,
  UPDATE_RESOURCE_REQUEST,
  UPDATE_RESOURCE_SUCCESS,
  UPDATE_RESOURCE_ERROR,
  SHOW_NOTIFICATION,
  UPDATE_RESOURCE_PASSWORD_REQUEST,
} from '../actions/resourceActionTypes';

function* fetchResource(params) {
  try {
    const {
      data: { data },
    } = yield call(Api.fetchResource, params);

    yield put({ type: FETCH_RESOURCE_SUCCESS, resource: data });
  } catch (res) {
    yield put({ type: FETCH_RESOURCE_ERROR, error: res });
  }
}

function* updateResource({ params }) {
  try {
    const {
      data: { data },
    } = yield call(Api.updateResource, params);

    yield put({ type: UPDATE_RESOURCE_SUCCESS, resource: data });
    yield put({
      type: SHOW_NOTIFICATION,
      notice: t('PROFILE_UPDATED_SUCCESSFULLY'),
      noticeType: 'notice',
    });
    // Wait for 3 secs before hiding notification
    yield delay(3000);
    yield put({ type: SHOW_NOTIFICATION, resourceUpdateNotice: null });
  } catch (res) {
    yield put({ type: UPDATE_RESOURCE_ERROR, error: res });
    yield put({
      type: SHOW_NOTIFICATION,
      notice:
        'There was an issue updating your profile. Refresh the page and try again.',
      noticeType: 'error',
    });
    // Wait for 3 secs before hiding notification
    yield delay(3000);
    yield put({ type: SHOW_NOTIFICATION, resourceUpdateNotice: null });
  }
}

function* updateResourcePassword({ params }) {
  try {
    const {
      data: { data },
    } = yield call(Api.updatePassword, params);

    yield put({ type: UPDATE_RESOURCE_SUCCESS, resource: data.data });
    yield put({
      type: SHOW_NOTIFICATION,
      notice: 'Password updated successfully',
      noticeType: 'notice',
    });
    // Wait for 3 secs before hiding notification
    yield delay(3000);
    yield put({ type: SHOW_NOTIFICATION, resourceUpdateNotice: null });
  } catch (res) {
    yield put({ type: UPDATE_RESOURCE_ERROR, error: res });
    yield put({
      type: SHOW_NOTIFICATION,
      notice:
        'There was an issue updating your password. Refresh the page and try again.',
      noticeType: 'error',
    });
    // Wait for 3 secs before hiding notification
    yield delay(3000);
    yield put({ type: SHOW_NOTIFICATION, resourceUpdateNotice: null });
  }
}

export const resourceSagas = [
  takeLatest(FETCH_RESOURCE_REQUEST, fetchResource),
  takeLatest(UPDATE_RESOURCE_REQUEST, updateResource),
  takeLatest(UPDATE_RESOURCE_PASSWORD_REQUEST, updateResourcePassword),
];
